module.exports = __webpack_public_path__ + "static/img/onboarding-complete-banner@2x.ef12bd88.png";